<template>
  <v-card elevation="0" v-if="cuenta">
    <v-col cols="12">
      <div class="" style="background-color: #FFFFFF">
        <div style="background-color: #FFFFFF">
          <p
            v-if="!cuenta.voto_particular &&
                  role=='magistrado' &&
                  cuenta.status<=44 &&
                  !voto_particular
                 "
            class=" font-weight-bold text-15" style="color:#1D2E4B">
              Si desea registrar voto particular, de click en el botón Registrar Voto Particular
              <span class="mx-3">
                <v-btn  small color="#3F5062" dark class="ml-8"
                 @click="voto_particular = true"
                >Registrar Voto Particular</v-btn>
              </span>
          </p>
          <p
            v-if="!cuenta.voto_concurrente &&
                  role=='magistrado' &&
                  cuenta.status<=44 &&
                  !voto_concurrente
                 "
            class=" font-weight-bold text-15" style="color:#1D2E4B">
              Si desea registrar voto concurrente, de click en el botón Registrar Voto Concurrente
              <span class="mx-3">
                <v-btn small color="#3F5062" dark
                 @click="voto_concurrente = true"
                >Registrar Voto Concurrente</v-btn>
              </span>
          </p>
        </div>

        <!-- VOTOS-->
        <v-row>
          <v-col cols="6" v-if="voto_particular || (cuenta && cuenta.voto_particular)">
            <v-card elevation="2">
              <v-card-title class="text-h6">
                <v-icon left>
                  mdi-vote
                </v-icon>
                VOTO PARTICULAR
              </v-card-title>
              <v-card-subtitle
                v-if="cuenta && cuenta.voto_particular"
                class="text-h8 mb-6"
              >
                <v-list-item-title class="mt-3 mb-3">
                  {{ cuenta.voto_particular.magistrado_nombre }}
                </v-list-item-title>
                {{ cuenta.voto_particular.observaciones }}
              </v-card-subtitle>
             <v-card-subtitle v-if="cuenta && voto_particular">
                <v-autocomplete
                  dense
                  class="mt-n1"
                  outlined
                  label="Seleccione un magistrado"
                  :item-text="item => item.magistrado"
                  item-value="user_id"
                  persistent-hint
                  :items = "getAllPonencias"
                  v-model="mag_voto_particular"
                />
                <v-textarea
                  class="mt-n4 mb-n3"
                  v-model="observaciones_particular"
                  outlined
                  placeholder="Observaciones del Voto Particular"
                  rows="1"
                ></v-textarea>
              </v-card-subtitle>
              <v-card-actions class="mt-n9">
                <v-spacer></v-spacer>
                <v-btn
                  v-if="cuenta && !cuenta.voto_particular"
                  @click="voto_particular=false,
                          observaciones_particular='',
                          mag_voto_particular=''
                        "
                  color="red"
                  text
                >
                  Cancelar
                </v-btn>
                <v-btn
                 v-if="cuenta && !cuenta.voto_particular"
                  @click="guardarVoto('P')"
                  color="orange"
                  text
                >
                  Guardar
                </v-btn>
                <v-btn
                  v-if="cuenta && cuenta.voto_particular && cuenta.status != 45"
                  @click="clickEliminarVoto(cuenta.voto_particular)"
                  color="red"
                  text
                >
                  Eliminar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="6" v-if="voto_concurrente || (cuenta && cuenta.voto_concurrente)">
            <v-card elevation="2">
              <v-card-title class="text-h6">
                <v-icon left>
                  mdi-vote
                </v-icon>
                VOTO CONCURRENTE
              </v-card-title>
              <v-card-subtitle
                v-if="cuenta && cuenta.voto_concurrente"
                class="text-h8 mb-6"
              >
                <v-list-item-title class="mt-3 mb-3">
                  {{ cuenta.voto_concurrente.magistrado_nombre }}
                </v-list-item-title>
                {{ cuenta.voto_concurrente.observaciones }}
              </v-card-subtitle>
              <v-card-subtitle v-if="cuenta && voto_concurrente">
                <v-autocomplete
                  dense
                  class="mt-n1"
                  outlined
                  label="Seleccione un magistrado"
                  :item-text="item => item.magistrado"
                  item-value="user_id"
                  persistent-hint
                  :items = "getAllPonencias"
                  v-model="mag_voto_concurrente"
                />
                <v-textarea
                  class="mt-n4 mb-n3"
                  v-model="observaciones_concurrente"
                  outlined
                  placeholder="Observaciones del Voto Concurrente"
                  rows="1"
                ></v-textarea>
              </v-card-subtitle>
              <v-card-actions class="mt-n9">
                <v-spacer></v-spacer>
                <v-btn
                  v-if="cuenta && !cuenta.voto_concurrente"
                  @click="voto_concurrente=false,
                          mag_voto_concurrente='',
                          observaciones_concurrente=''
                        "
                  color="red"
                  text
                >
                  Cancelar
                </v-btn>
                <v-btn
                 v-if="cuenta && !cuenta.voto_concurrente"
                  @click="guardarVoto('C')"
                  color="orange"
                  text
                >
                  Guardar
                </v-btn>
               <v-btn
                  v-if="cuenta && cuenta.voto_concurrente  && cuenta.status != 45"
                  @click="clickEliminarVoto(cuenta.voto_concurrente)"
                  color="red"
                  text
                >
                  Eliminar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

      </div>
    </v-col>
  </v-card>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import { VueEditor } from 'vue2-editor';
import BaseSelect from "@/components/BaseSelect.vue";
import Autocomplete from "@/components/Autocomplete";

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    role: {
      type: String,
      required: true
    }
  },
  data: () => ({
    voto_concurrente: false,
    voto_particular: false,
    mag_voto_particular: '',
    mag_voto_concurrente: '',
    cuenta: null,
    observaciones_particular: '',
    observaciones_concurrente: ''
  }),
  mounted(){
    this.cuenta = this.item
  },
  computed: {
    ...mapGetters(["getAllPonencias", "currentUser"]),
  },
  methods:{
    guardarVoto(tipo){
      if (tipo=='P') {
        this.magistrado = this.mag_voto_particular
        this.observaciones = this.observaciones_particular
      } else {
        this.magistrado = this.mag_voto_concurrente
        this.observaciones = this.observaciones_concurrente
      }
      if (!this.magistrado && !this.observaciones) {
        this.$swal({
          title: "Error!!!",
          text: 'Favor de seleccionar magistrado y/o agregar observaciones',
          icon: "error",
          confirmButtonText: "Aceptar"
        });
        return false;
      }
      this.$store.dispatch('CREATE_OBSERVACION_COLEGIADA', {
        url: '/colegiada/' + this.cuenta.id + '/voto',
        data: {
          cuenta_id: this.cuenta.id,
          user_id: this.currentUser.id,
          magistrado_id: this.magistrado,
          observaciones: this.observaciones,
          tipo: tipo
        }
      }).then(response => {
        if (response.data.status == "ok") {
          if (tipo=='P') {
            this.cuenta.voto_particular = response.data.data.voto
            this.observaciones_particular = ''
          } else {
            this.cuenta.voto_concurrente = response.data.data.voto
            this.observaciones_concurrente = ''
          }
          this.$swal({
            title: "Éxito!!!",
            text: 'Voto agregado correctamente',
            icon: "success",
            confirmButtonText: "Aceptar"
          });
          this.voto_particular = false
          this.voto_concurrente = false
          this.mag_voto_particular = ''
          this.mag_voto_concurrente = ''
          this.observaciones=''
        }
      }).catch(error => {
        console.log(error);
        this.loading = false;
        this.$swal({
          title: "Error",
          text: "Error al guardar",
          icon: "error",
          confirmButtonText: "Aceptar"
        });
      });
    },
    clickEliminarVoto(item){
      this.$swal({
       title: '¿Desea eliminar ' + (item.tipo == 'P' ? 'voto particular?' : 'voto concurrente?'),
       text: '',
       icon: 'question',
       showCancelButton: true,
       confirmButtonText: "Aceptar"
     }).then((result) => {
       if (result.value) {
         this.eliminarVoto(item);
       }
     })
    },
    eliminarVoto(item){
      this.$store.dispatch("DELETE_SENTIDO",  { url: "/voto/" + item.id } ).then(res => {
        if (item.tipo == 'P') {
          this.cuenta.voto_particular = null
        } else {
          this.cuenta.voto_concurrente = null
        }
        this.$swal({
          title: "Exito!!!",
          text: "Voto eliminado correctamente",
          icon: "success",
          confirmButtonText: "Aceptar"
        });
      });
    },
  }
}
</script>
